<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <h1>Bosseln-Regeln</h1>
        <ul>
          <li>Ziel des Spiels: Die Kugel mit möglichst wenigen Würfen ins Ziel bringen.</li>
          <li>Die Teams werfen abwechselnd.</li>
          <li>Das Team mit den wenigsten Würfen gewinnt.</li>
          <li>Trinkpausen an Kreuzungen!</li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RulesPage",
};
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
}
ul {
  font-size: 1.2rem;
  margin-left: 1.5rem;
}
</style>